import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Usuario} from "../../shared";
import { UsuarioService } from '../../shared/service/usuario/usuario.service';
import { LoginService } from '../../shared/service/login/login.service';
import { SegurancaService } from '../../shared/service/seguranca/seguranca.service';
import { environment } from '../../../environments/environment';
import { UtilService } from '../../shared/service/util/util.service';

export interface FormModel {
  captcha?: string;
}

@Component({
  selector: 'app-reset-senha',
  templateUrl: './reset-senha.component.html',
  styleUrls: ['./reset-senha.component.css']
})
export class ResetSenhaComponent implements OnInit {

  public formModel: FormModel = {};
  public usuario: Usuario;
  public regex : string;
  public descricaoRegex : string;
  public recaptchaSiteKey : string;

  public confirm: string;
  
  @ViewChild('captchaProtectedForm', { static: true }) form;

  constructor(
    private route: ActivatedRoute,
    private utilService: UtilService,
    private usuarioService: UsuarioService,
    private loginService : LoginService,
    private segurancaService : SegurancaService) { 

  }

  ngOnInit() {
    const token = this.route.snapshot.params.token;

    this.usuarioService.obterDadosUsuarioPorToken(token).subscribe(
      res => {
        this.usuario = res;
        this.usuario.token = this.route.snapshot.params.token;
        this.recaptchaSiteKey = environment.recaptchaSiteKey;
        this.obterPoliticaSenhaPadrao();
      },
      err => {
        this.loginService.logout();
        localStorage.setItem('errMessage', err.message);
      }
    );
  }

  onSubmit(){
    
    this.usuarioService.alteraSenha(this.usuario).subscribe(
      res => {
          localStorage.setItem("message", "Senha alterada com sucesso.")
          this.loginService.logout();
      },
      err => {
        if(err.status === 401 || err.status === 403){
          this.loginService.logout();
        }
        
        this.utilService.showError(err.message);
      }
  );

  }

  obterPoliticaSenhaPadrao() {
    this.segurancaService.obterPoliticaSenha().subscribe(
          res => {
              this.regex = res.regex;
              this.descricaoRegex = res.descricao;
          },
          err => {

              if(err.status === 401 || err.status === 403){
                this.loginService.logout();
              }
              this.utilService.showError(err.message);
          }
    );
  }
}